<!-- eslint-disable vue/first-attribute-linebreak -->
<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>

    <div class="row mb-5">
      <div class="col-12">
        <div class="card mt-2">
          <div class="card-header mb-0">
            <h5>{{ $t('apps.gdeletelineregis') }}</h5>
          </div>
          <div class="card-body pt-0">

            <!-- Customer Search Row -->
            <div class="row">
              <div class="col-lg-4 mt-2">
                <label class="form-label ms-0">{{ $t('content.names') }}</label>
                <div class="input-group">
                  <input v-model="cusName_search" type="text" class="form-control" readonly />
                  <button class="btn btn-primary" type="button" @click="openDialogCus">
                    <i class="material-icons material-symbols-outlined">search</i>
                  </button>
                  <button id="searchNameCus" class="btn btn-primary" type="button" data-bs-toggle="modal"
                    data-bs-target="#searchNameModal" v-show="false">
                  </button>
                </div>
              </div>
              <div class="col-lg-2 mt-2">
                <label class="form-label ms-0">&nbsp;</label>
                <div>
                  <material-button color="danger" class="mb-0" @click="clearSearch">
                    <i class="material-icons material-symbols-outlined">close</i>
                    {{ $t('buttons.canc') }}
                  </material-button>
                </div>
              </div>
            </div>

            <!-- Line Registration Table -->
            <div class="row mt-4" v-if="cusUid_search !== ''">
              <hr />
              <div class="table-responsive">
                <table class="table table-flush">
                  <thead class="thead-light">
                    <tr>
                      <th>#</th>
                      <th>{{ $t('content.cnameth') }}</th>
                      <th>{{ $t('content.cnameen') }}</th>
                      <th>{{ $t('content.docno') }}</th>
                      <th>{{ $t('apps.linename') }}</th>
                      <th>{{ $t('content.act') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(row, index) in lineList" :key="index">
                      <td class="text-sm font-weight-normal">{{ index + 1 }}</td>
                      <td class="text-sm font-weight-normal">{{ cusNameTh_search }}</td>
                      <td class="text-sm font-weight-normal">{{ cusNameEn_search }}</td>
                      <td class="text-sm font-weight-normal">{{ cusDocNumber_search }}</td>
                      <td class="text-sm font-weight-normal">{{ row.displayName }}</td>
                      <td class="text-sm font-weight-normal">
                        <material-button color="danger" variant="outline" class="rounded-circle"
                          :title="t('buttons.dele')" @click="confirmDeleteLine(row)">
                          <i class="material-icons material-symbols-outlined">delete</i>
                        </material-button>
                      </td>
                    </tr>
                    <tr v-if="lineList.length === 0">
                      <td colspan="6" class="text-sm font-weight-normal">
                        <p style="text-align: center">No Record Found</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Customer Search Modal -->
    <div id="searchNameModal" class="modal fade" tabindex="-1" aria-labelledby="searchNameModalLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">{{ $t('content.cnamelist') }}</h4>
            <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeModal">
              <i class="material-icons material-symbols-outlined">close</i>
            </button>
          </div>

          <div class="modal-body">
            <div class="preview-table">
              <section class="panel">
                <table class="table table-striped table-responsive">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{{ $t('content.cnameth') }}</th>
                      <th>{{ $t('content.cnameen') }}</th>
                      <th>{{ $t('content.docno') }}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="row-search">
                      <td></td>
                      <td>
                        <material-input v-model="nameThC" type="text" :label="t('content.cnameth')" />
                      </td>
                      <td>
                        <material-input v-model="nameEnC" type="text" :label="t('content.cnameen')" />
                      </td>
                      <td>
                        <material-input v-model="docNumberC" type="text" :label="t('content.docno')" />
                      </td>
                      <td>
                        <material-button color="primary" variant="contain" class="rounded-circle ms-1"
                          :disabled="nameThC.length < 2 && nameEnC.length < 2 && docNumberC.length < 5"
                          @click="loadCustomerListApi">
                          <i class="material-icons material-symbols-outlined">search</i>
                        </material-button>
                      </td>
                    </tr>
                    <tr v-for="(row, index) in customerList" :key="index" style="cursor:pointer"
                      @click="selectCustomer(row)">
                      <td>{{ (currentPageC - 1) * perPageC + index + 1 }}</td>
                      <td>{{ row.nameTh }}</td>
                      <td>{{ row.nameEn }}</td>
                      <td colspan="2">{{ row.docNumber }}</td>
                    </tr>
                    <tr v-if="customerList.length === 0">
                      <td colspan="5" class="text-sm font-weight-normal">
                        <p style="text-align: center">No Record Found</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </section>
            </div>
          </div>

          <div class="modal-footer">
            <pre></pre>
            <div style="display: flex; justify-content: flex-end">
              <ul v-show="customerList.length > 0" class="pagination justify-content-end">
                <div class="project-container">
                  <div class="example-one">
                    <vue-awesome-paginate v-model="currentPageC" :total-items="totalRowsC"
                      :items-per-page="perPageC" @click="onClickHandlerC" />
                  </div>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import { ref, inject } from "vue";
import { useI18n } from "vue-i18n";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import axios from "axios";
import * as st from "@/config/setting.js";

import { useCustomerStore } from '@/stores/customer';
import { useCusLineStore } from '@/stores/cusline';
import { useSecUsersStore } from '@/stores/secusers';
import { useUserSecurityStore } from "@/stores/usersecurity";


const storecus = useCustomerStore();
const storeline = useCusLineStore();
const storesec = useSecUsersStore();
const userSStore = useUserSecurityStore();

const { t } = useI18n();
const swal = inject("$swal");

const key = JSON.parse(localStorage.getItem("shop_seleted"));

const loading = ref(false);

// Customer search state
const cusUid_search = ref('');
const cusName_search = ref('');
const cusNameTh_search = ref('');
const cusNameEn_search = ref('');
const cusDocNumber_search = ref('');
const nameThC = ref('');
const nameEnC = ref('');
const docNumberC = ref('');
const customerList = ref([]);
const currentPageC = ref(1);
const totalRowsC = ref(1);
const perPageC = ref(10);

// Line list state
const lineList = ref([]);


function clearSearch() {
  cusUid_search.value = '';
  cusName_search.value = '';
  cusNameTh_search.value = '';
  cusNameEn_search.value = '';
  cusDocNumber_search.value = '';
  lineList.value = [];
  nameThC.value = '';
  nameEnC.value = '';
  docNumberC.value = '';
  customerList.value = [];
}

async function openDialogCus() {
  nameThC.value = '';
  nameEnC.value = '';
  docNumberC.value = '';
  cusUid_search.value = '';
  cusName_search.value = '';
  cusNameTh_search.value = '';
  cusNameEn_search.value = '';
  cusDocNumber_search.value = '';
  customerList.value = [];
  lineList.value = [];
  document.getElementById("searchNameCus").click();
}

async function loadCustomerListApi() {
  currentPageC.value = 1;
  const payload = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value,
    groupUid: key.groupUid,
    shopUid: key.uid
  };
  const response = await storecus.searchCustomerFetch(payload);
  if (response?.status === 200 && response.data.rtnDesc === 'success') {
    customerList.value = response.data.data.list;
    totalRowsC.value = response.data.data.ext.total;
  }
}

async function onClickHandlerC() {
  const payload = {
    index: currentPageC.value - 1,
    size: perPageC.value,
    nameEn: nameEnC.value,
    nameTh: nameThC.value,
    docNumber: docNumberC.value,
    groupUid: key.groupUid,
    shopUid: key.uid
  };
  const response = await storecus.searchCustomerFetch(payload);
  if (response?.status === 200 && response.data.rtnDesc === 'success') {
    customerList.value = response.data.data.list;
    totalRowsC.value = response.data.data.ext.total;
  }
}

async function selectCustomer(item) {
  cusUid_search.value = item.uid;
  cusName_search.value = item.nameTh;
  cusNameTh_search.value = item.nameTh;
  cusNameEn_search.value = item.nameEn;
  cusDocNumber_search.value = item.docNumber;
  document.getElementById("closeModal").click();
  await loadLineListApi();
}

async function loadLineListApi() {
  if (!cusUid_search.value) return;
  loading.value = true;
  const payload = {
    index: 0,
    size: 100,
    cusUid: cusUid_search.value,
    shopUid: key.uid,
    groupUid: key.groupUid,
  };
  const response = await storeline.cusLineListFetch(payload);
  loading.value = false;
  if (response?.status === 200 && response.data.rtnDesc === 'success') {
    lineList.value = response.data.data.list ?? [];
  } else {
    lineList.value = [];
  }

}

async function confirmDeleteLine(row) {
  swal({
    title: t('apps.gdeletelineregis'),
    text: `ต้องการลบ LINE "${row.displayName}" ของลูกค้า "${cusName_search.value}" ใช่ไหม?`,
    icon: "warning",
    allowOutsideClick: false,
    showCancelButton: true,
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    confirmButtonColor: "#d33",
  }).then(async (result) => {
    if (!result.isConfirmed) return;
    await deleteLine(row);
  });
}

async function deleteLine(row) {
  loading.value = true;
  let lineDeleteOk = false;

  try {
    // Step 1: Re-list cus-svc lines with cusUid + shopUid, then delete
    const linesRes = await storeline.cusLineListFetch({
      index: 0,
      size: 100,
      cusUid: cusUid_search.value,
      shopUid: key.uid,
      groupUid: key.groupUid,
    });
    if (linesRes?.status === 200 && linesRes.data.rtnDesc === 'success') {
      const list = linesRes.data.data.list ?? [];
      const target = list.find(l => l.uid === row.uid) ?? list[0];
      if (target) {
        const delRes = await storeline.cusLineDeleteFetch({ uid: target.uid });
        lineDeleteOk = delRes?.status === 200;
        
        if (lineDeleteOk) {
          // Step 2: List sec-svc customer with cusUid + shopUid, then delete session
          await getClientToken(); // Ensure client token is set
        }

      }
    }
  } catch (e) {
    // silent
  }

  loading.value = false;

  if (lineDeleteOk) {
    swal("ลบสำเร็จ", "ลบการลงทะเบียน LINE เรียบร้อยแล้ว", "success");
    await loadLineListApi();
  } else {
    swal("เกิดข้อผิดพลาด", "ไม่สามารถลบการลงทะเบียน LINE ได้", "error");
  }
}

async function getClientToken() {
  //console.log("กำลังเรียก getClientToken...");
  loading.value = true; // เปิด loading (ปรับตามชื่อตัวแปรสปินเนอร์ของคุณได้ครับ)
  try {
    // 1. เรียกดึง clientToken โดยใช้ axios ดิบๆ ยิงตรง
    const res = await userSStore.client_access_token();
    //console.log("ข้อมูล res ที่รับกลับมาในไฟล์หลัก:", res);

    if (res && res.access_token) {
      const clientToken = res.access_token;
      //console.log("✅ Token สำเร็จแล้ว! ค่าคือ:", clientToken);

      // เตรียม Config พิเศษที่มีเฉพาะ clientToken ยิงตรง ไม่ผ่าน interceptor
      const apiConfig = {
        headers: {
          Authorization: `Bearer ${clientToken}`,
          "Content-Type": "application/json"
        }
      };

      // 2. เรียก API ค้นหารายการ (ใช้ axios ดิบ ยิงตรงระบุ URL เต็ม)
      // 💡 หมายเหตุ: ให้เปลี่ยนคำว่า `st.url_api` เป็นตัวแปร URL หลักปลายทางของโปรเจกต์คุณนะครับ
      const listUrl = st.sec_url_api + "/sec-svc/customer/list"; 
      const listBody = {
        page: { index: 0, size: 100, sort: "" },
        filter: { 
          cusUid: cusUid_search.value, 
          shopUid: key.uid, 
          lineUserId: "" 
        }
      };

      const secRes = await axios.post(listUrl, listBody, apiConfig);
      //console.log("ผลลัพธ์การยิงดึง List สำเร็จ:", secRes);

      if (secRes?.status === 200 && secRes.data.rtnDesc === 'success') {
        const secList = secRes.data.data?.list ?? [];
        
        if (secList.length > 0) {
          //console.log("พบรายการ sec-svc customer กำลังเตรียมลบ:", secList);
          
          // 3. ลบรายการแรกเมื่อตรวจพบข้อมูล (ใช้ axios ดิบ ยิงตรง)
          const deleteUrl = st.sec_url_api + "/sec-svc/customer/delete/" + secList[0].uid;
          const deleteRes = await axios.delete(deleteUrl, apiConfig);
          //console.log("ผลลัพธ์การลบสำเร็จ:", deleteRes);
        }
      }
    } else {
      console.log("⚠️ เงื่อนไขไม่ผ่าน: ไม่มี access_token ในตัวแปร res");
    }
  } catch (error) {
    console.error("❌ เกิดข้อผิดพลาดในการทำงานยิงตรง:", error);
  } finally {
    loading.value = false; // ปิด loading
  }
}

</script>
<style lang="scss" scoped>
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
